var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hiddenScrollbar detail" }, [
    _c(
      "div",
      { staticClass: "Spot-Info box" },
      [
        _c("w-image", {
          ref: "wImage",
          attrs: {
            imageUrl: _vm.community.imageUrl,
            pictures: _vm.community.pictures,
          },
          nativeOn: {
            click: function ($event) {
              return _vm.showImages.apply(null, arguments)
            },
          },
        }),
        _c("div", { staticClass: "Right" }, [
          _c("div", { staticClass: "Right-Top" }, [
            _c("div", { staticClass: "Right-One Right-Padding" }, [
              _vm.community.score
                ? _c("span", [
                    _vm._v(_vm._s(_vm.community.score)),
                    _c("span", { staticStyle: { "font-size": "15px" } }, [
                      _vm._v("分"),
                    ]),
                  ])
                : _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v("暂无评分"),
                  ]),
            ]),
            _c("div", { staticClass: "Right-One-Spot Right-Padding" }, [
              _c("p", [
                _vm._v(
                  "使用率：" +
                    _vm._s(_vm.community.otherResourceData.usageRate) +
                    "%"
                ),
              ]),
              _c("p", [
                _vm._v(
                  "排名：" + _vm._s(_vm.community.otherResourceData.ranking)
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "Right-Two Right-Padding" },
              [
                _vm.community.star
                  ? _c("el-rate", {
                      attrs: { max: _vm.community.star, disabled: "" },
                      model: {
                        value: _vm.community.star,
                        callback: function ($$v) {
                          _vm.$set(_vm.community, "star", $$v)
                        },
                        expression: "community.star",
                      },
                    })
                  : _vm._e(),
                _vm.community.addressCn
                  ? _c("i", {
                      staticClass: "el-icon-location-outline van-icon",
                    })
                  : _vm._e(),
                _c("span", { staticClass: "ellipsis" }, [
                  _vm._v(_vm._s(_vm.community.addressCn)),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm.community.otherResourceData.openingTime
      ? _c("div", { staticClass: "Traffic box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "jingdian" },
              }),
              _vm._v("开园时间"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.otherResourceData.openingTime))]
          ),
        ])
      : _vm._e(),
    _vm.community.introduction
      ? _c("div", { staticClass: "Introduce box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "jianjie" },
              }),
              _vm._v("简介"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.introduction))]
          ),
        ])
      : _vm._e(),
    _vm.community.stockListResults
      ? _c("div", { staticClass: "Price box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "jiage" },
              }),
              _vm._v("价格详情"),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "Price-Box" },
            [
              _c("div", { staticClass: "Price-Top" }, [
                _c(
                  "span",
                  {
                    class: _vm.spanCheck == 1 ? "active-span" : "",
                    on: {
                      click: function ($event) {
                        return _vm.setSpanCheck(1)
                      },
                    },
                  },
                  [
                    _c("svg-icon", {
                      staticClass: "icon-title",
                      attrs: { iconClass: "mengpiao" },
                    }),
                    _vm._v("门票"),
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    class: _vm.spanCheck == 2 ? "active-span" : "",
                    on: {
                      click: function ($event) {
                        return _vm.setSpanCheck(2)
                      },
                    },
                  },
                  [_vm._v("年季卡")]
                ),
                _c(
                  "span",
                  {
                    class: _vm.spanCheck == 3 ? "active-span" : "",
                    on: {
                      click: function ($event) {
                        return _vm.setSpanCheck(3)
                      },
                    },
                  },
                  [_vm._v("特色体验项")]
                ),
                _c(
                  "span",
                  {
                    class: _vm.spanCheck == 4 ? "active-span" : "",
                    on: {
                      click: function ($event) {
                        return _vm.setSpanCheck(4)
                      },
                    },
                  },
                  [_vm._v("门票+项目组")]
                ),
              ]),
              _vm._l(_vm.community.stockListResults, function (item, index) {
                return _c(
                  "p",
                  { key: index, staticClass: "Price-Hang box-content" },
                  [
                    _c("span", [_vm._v(_vm._s(item.productNameCn))]),
                    item.cancelType == 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("不可取消"),
                        ])
                      : _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("有条件退"),
                        ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm.community.otherResourceData.arrivalTraffic
      ? _c("div", { staticClass: "Traffic box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "jiaotong" },
              }),
              _vm._v("周边交通"),
            ],
            1
          ),
          _c("p", {
            staticClass: "box-content",
            staticStyle: { color: "#323232" },
            domProps: {
              innerHTML: _vm._s(_vm.community.otherResourceData.arrivalTraffic),
            },
          }),
        ])
      : _vm._e(),
    _vm.community.otherResourceData.tips
      ? _c("div", { staticClass: "Traffic box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "guanwang" },
              }),
              _vm._v("官网及联系电话"),
            ],
            1
          ),
          _vm.community.website
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [_vm._v("web：" + _vm._s(_vm.community.website))]
              )
            : _vm._e(),
          _vm.community.phone
            ? _c(
                "p",
                {
                  staticClass: "box-content",
                  staticStyle: { color: "#323232" },
                },
                [_vm._v("phone：" + _vm._s(_vm.community.phone))]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.community.otherResourceData.tips
      ? _c("div", { staticClass: "Traffic box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "jiage" },
              }),
              _vm._v("温馨提示"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.otherResourceData.tips))]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }